
import { Component, computed, input, model, OnInit, signal } from "@angular/core";

@Component({
  selector: 'observable-errors-warnings',
  templateUrl: './errors-warnings.component.html',
  styleUrls: ['./errors-warnings.component.scss'],
  imports: [],
  standalone: true
})
export class ErrorsWarningsComponent implements OnInit {
  public obj = model<any>(null);
  public props = input<string[]>([]);
  public bottomMargin = input(1);
  public useSingleAlert = input(false);
  public supressErrors = input(false);

  //  These two are used specifically for when we want to display a very specific error
  //  or warning that isn't tied to the errors/warnings of an object.
  public nonInputErrors = input<string[]>([]);
  public nonInputWarnings = input<string[]>([]);

  public additionalAlertClasses = input<string>('');

  public hasErrorsSig = computed(() => {
    const errors = this.obj()?.errorsSig();
    return this.props().some(prop => errors[prop]);
  });

  public hasWarningsSig = computed(() => {
    const warnings = this.obj()?.warningsSig();
    return this.props().some(prop => warnings[prop]);
  });

  constructor() {}

  public ngOnInit(): void {
    if (!this.obj() && !this.nonInputErrors()?.length && !this.nonInputWarnings()?.length)
    throw new Error('Invalid configuration: Must provide an obj for observable errors/warnings.  Alternatively provide nonInputErrors or nonInputWarnings for manual alerts.');

    //  If we're using errors/warnings not bound to an object, set up a dummy object to keep the HTML simpler.
    if (!!this.nonInputErrors()?.length || !!this.nonInputWarnings()?.length) {
      this.obj.set({
        errors: {},
        warnings: {},
        errorsSig: signal<any>({}),
        warningsSig: signal<any>({}),
        validate: () => null,
      });

      if (!!this.nonInputErrors()?.length) {
        let errorIndex = 0;
        for (let error of this.nonInputErrors()) {
          const prop = `error_${errorIndex}`;
          this.obj().errors[prop] = error;
          this.props().push(prop);
          errorIndex++;
        }
      }

      if (!!this.nonInputWarnings()?.length) {

        let warningIndex = 0;
        for (let warning of this.nonInputWarnings()) {
          const prop = `warning_${warningIndex}`;
          this.obj().warnings[prop] = warning;
          this.props().push(prop);
          warningIndex++;
        }
      }

      this.obj().errorsSig.set(this.obj().errors);
      this.obj().warningsSig.set(this.obj().warnings);
    }
  }
}
